export default function (R) {
  var UNDEF,
    math = Math,
    mathAtan2 = math.atan2,

    NONE = 'none',
    FILL = 'fill',
    PATH = 'path',
    CUBEPATH = 'cubepath';

  R.define && R.define([{
    name: 'cubepath',
    // args: [x, y, w, h, zw, zh]
    cubepath: function () {
      var paper = this,
        shapeDefaultAttrs = {
          'stroke-linejoin': 'round',
          'shape-rendering': 'precision',
          'stroke': NONE
        },
        args = arguments,
        lastArg = args.length - 1,
        group = args[lastArg],
        top,
        side,
        a,
        face,
        generateCubepath = function (x, y, w, h, zw, zh) {
          var o = this,
            t = o._.cubetop,
            s = o._.cubeside;

          if (typeof x === 'object' || (x === UNDEF && y === UNDEF && w === UNDEF && h === UNDEF &&
                                  zw === UNDEF && zh === UNDEF)) {
            return this;
          }

          x = x || o.attrs.x || 0;
          y = y || o.attrs.y || 0;
          w = w || o.attrs.width || 0;
          h = h || o.attrs.height || 0;
          zw = zw || o.attrs.xDepth || 0;
          zh = zh || o.attrs.yDepth || 0;

          o.attrs.x = x;
          o.attrs.y = y;
          o.attrs.width = w;
          o.attrs.height = h;
          o.attrs.xDepth = zw;
          o.attrs.yDepth = zh;

          /* The issue of pixel wide gap found between adjacent faces when input params
                      * are not all intezers, is solved by adding extra portion in top and side faces.
                      * The side face is extended to the left with a pixel wide rectange, whole top
                      * end is cut diagonally to avoid overlapping stoke effect. Like wise, the top face
                      * is extended below with a pixel height rectangle whose left end is cut diagonally for
                      * the same rason as above. Motive was to keep the bounding box intact as intended.
                      */
          o._attr(PATH, ['M', x + w, y, 'l', 0, h, -w, 0, 0, -h, 'z']);
          t.attr(PATH, ['M', x, y, 'l', 1, 1, w - 1, 0, 0, -1, zw, -zh, -w, 0, 'z']);
          s.attr(PATH, ['M', x + w - 1, y + 1, 'l', 0, h - 1, 1, 0, zw, -zh, 0, -h, -zw, zh]);

          return this;
        },
        dropShadow = function (dx, dy, spread, color) {
          var o = this,
            top = o._.cubetop,
            side = o._.cubeside;

          // Only allow filter based shadow.
          if (o.dropshadow) {
            top.dropshadow(dx, -dy, spread, color);
            side.dropshadow(dx, -dy, spread, color);
          }

          return false;
        };

      group && (group.constructor === R.el.constructor) ?
        (args[lastArg] = UNDEF) : (group = UNDEF);

      top = paper.path(shapeDefaultAttrs, group);
      side = paper.path(shapeDefaultAttrs, group);
      face = paper.path(shapeDefaultAttrs, group);

      face._.cubetop = top.follow(face, UNDEF, 'before');
      face._.cubeside = side.follow(face, UNDEF, 'before');

      for (a in R.fn.cubepath.ca) {
        face.ca[a] = R.fn.cubepath.ca[a];
      }

      face._attr = face.attr;
      face._shadow = face.shadow;

      face.attr = function (name, value) {
        var isObject = (typeof (name) === 'object');
        if (isObject) {
          // When cubepath is given as an array of inputs
          if (name.cubepath) {
            value = [...name.cubepath];
          } else {
            value = [];
            value.push(name.x);
            value.push(name.y);
            value.push(name.width);
            value.push(name.height);
            value.push(name.xDepth);
            value.push(name.yDepth);
          }
          if (name.noGradient !== UNDEF) {
            face.attrs.noGradient = name.noGradient;
          }
        }

        if (name === UNDEF && value === UNDEF) {
          return this.attrs;
        } else if (value === UNDEF) {
          return this.attrs[name];
        }

        if (isObject) {
          generateCubepath.apply(this, value);
        } else if (name === 'drop-shadow') {
          dropShadow.apply(this, [].concat(value));
        }
        face._attr(name);

        return this;
      };

      face.appendTo = function (group) {
        group.appendChild(face._.cubetop);
        group.appendChild(face._.cubeside);
        group.appendChild(face);
      };

      if (typeof args[0] === 'object') {
        return face.attr(args[0]);
      }
      // return face.attr(CUBEPATH, [args[0], args[1], args[2], args[3], args[4], args[5]]);
      return generateCubepath.apply(face, [args[0], args[1], args[2], args[3], args[4], args[5]]);
    },
    fn: {
      // Return the bounding box of the back face of the 3D shape.
      // This is an internal function, which is not implemented to the complete level, as such
      // there is no proper definition the function is supposed to do, hence it is prefixed with
      // an '_' and named as _getBBox2
      _getBBox2: function () {
        var shape = this,
          sideBox = shape._.cubeside.getBBox(),
          topBox = shape._.cubetop.getBBox(),
          bbox = shape.getBBox();

        // Calculate the backface bbox like object consisting of x,y width, height
        // using the sideBox,topBox,bBox
        return {
          x: bbox.x + topBox.height,
          y: bbox.y - sideBox.width,
          width: bbox.width,
          height: bbox.height
        };
      },
      shadow: function () {
        this._.cubeside.shadow.apply(this._.cubeside, arguments);
        this._.cubetop.shadow.apply(this._.cubetop, arguments);
        return this._shadow.apply(this, arguments);
      }
    },
    ca: {
      'stroke-linejoin': function () {
        // We force the linejoin to always be round. Otherwise, the cube
        // edges will look horrible.
        return {
          'stroke-linejoin': 'round'
        };
      },

      'fill': function (color, nogradient) {
        var o = this,
          top = o._.cubetop,
          side = o._.cubeside,
          attr = o._attr(CUBEPATH) || [0, 0, 0, 0, 0, 0],
          width = attr[2],
          zw = attr[4],
          zh = attr[5],
          rgba;

        if (nogradient === UNDEF) {
          nogradient = o._attr('noGradient');
        }
        color = R.color(color);

        if (nogradient) {
          o._attr(FILL, color);
          top.attr(FILL, R.tintshade(color, -0.78).rgba);
          side.attr(FILL, R.tintshade(color, -0.65).rgba);
        } else {
          // Since the color has been already calculated in object form,
          // we manually recalculate the rgba here since re-sending object
          // to Raphael's tintshade can cause it to return stale result
          // from its cache.
          rgba = ('opacity' in color) ?
            ('rgba(' + [color.r, color.g, color.b, color.opacity] + ')') :
            ('rgb(' + [color.r, color.g, color.b] + ')');

          o._attr(FILL, [270, R.tintshade(rgba, 0.55).rgba,
            R.tintshade(rgba, -0.65).rgba].join('-'));
          side.attr(FILL, [270,
            R.tintshade(rgba, -0.75).rgba,
            R.tintshade(rgba, -0.35).rgba].join('-'));
          top.attr(FILL, [45 + R.deg(mathAtan2(zh, zw + width)),
            R.tintshade(rgba, -0.78).rgba,
            R.tintshade(rgba, 0.22).rgba].join('-'));
          /**
                     * @note
                    // This is the gradient calculation mapping that accounts for
                    // the skew of the top face.
                    o.attr(FILL, [285, R.tintshade(rgba, .55).rgba,
                        R.tintshade(rgba, -.65).rgba].join('-'));
                    side.attr(FILL, [50 + R.deg(mathAtan2(height + zh, zw)),
                        R.tintshade(rgba, -.45).rgba,
                        R.tintshade(rgba, -.75).rgba].join('-'));
                    top.attr(FILL, [R.deg(mathAtan2(zh, zw + width)),
                        R.tintshade(rgba, -.85).rgba,
                        R.tintshade(rgba, .35).rgba].join('-'));
                    */
        }

        // We return false so that the attribute is not applied to the
        // composite shape's leading element (the front face.)
        return false;
      }
    }
  }]);
}
